<template>
</template>

<script>
import VMyPageDashBoard from "@/components/organisms/parent/VMyPageDashBoard.vue"

export default {
  created: function () {
  }
}
</script>

